import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Emitir Notas", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_9 = {
  key: 2,
  class: "ant-row"
}
const _hoisted_10 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_17 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_18 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_19 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_20 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-15" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_26 = ["title"]
const _hoisted_27 = ["title"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { key: 3 }
const _hoisted_31 = { key: 4 }
const _hoisted_32 = { key: 5 }
const _hoisted_33 = {
  key: 6,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("b", null, "T.DOC:", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("b", null, "Vencimento:", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("b", null, "Valor NFSe:", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("b", null, "Conta:", -1)
const _hoisted_40 = {
  key: 0,
  class: "ant-row",
  style: {"min-height":"40px","align-items":"center"}
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Definir desconto nos títulos como:")
], -1)
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_43 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", null, "Aplicar em Todos", -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "ant-row" }
const _hoisted_47 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_48 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_49 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_50 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_servico = _resolveComponent("selecionar-servico")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_iss_retido = _resolveComponent("selecionar-iss-retido")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_totalizador = _resolveComponent("totalizador")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: "Emitir NFS-e dos Títulos Financeiros",
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    centered: "",
    width: "100%",
    "wrap-class-name": "ss-modal-financeiro",
    destroyOnClose: true
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "ant-btn ant-btn-lg ant-btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmarEmissao && _ctx.confirmarEmissao(...args)))
      }, _hoisted_2)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_card, {
            class: "ss-card-alinhado",
            titulo: "DADOS DO SERVIÇO"
          }, {
            default: _withCtx(() => [
              (_ctx.state.dados.codigoServico > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_a_form_item, {
                        label: "Serviço",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_servico, {
                            empresas: [_ctx.props.empresa],
                            codigoSelecionado: _ctx.state.dados.codigoServico,
                            "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.dados.codigoServico) = $event)),
                            onChange: _ctx.obterServico
                          }, null, 8, ["empresas", "codigoSelecionado", "onChange"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_a_form_item, {
                        label: "Descrição da Atividade",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            value: _ctx.state.servico.descricaoAtividadeEconomica,
                            disabled: true
                          }, null, 8, _hoisted_6)
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_a_form_item, {
                        label: "Serviço",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_servico, {
                            empresas: [_ctx.props.empresa],
                            codigoSelecionado: _ctx.state.dados.codigoServico,
                            "onUpdate:codigoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.dados.codigoServico) = $event)),
                            onChange: _ctx.obterServico
                          }, null, 8, ["empresas", "codigoSelecionado", "onChange"])
                        ]),
                        _: 1
                      })
                    ])
                  ])),
              (_ctx.state.dados.codigoServico > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_a_form_item, {
                        label: "CNAE",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            value: _ctx.state.servico.codigoAtividadeEconomica,
                            disabled: true
                          }, null, 8, _hoisted_11)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_a_form_item, {
                        label: "Item Lista Serviço",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            value: _ctx.state.servico.codigoItemListaServico,
                            disabled: true
                          }, null, 8, _hoisted_13)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_a_form_item, {
                        label: "Trib. Município",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            value: _ctx.state.servico.codigoTributacaoMunicipio,
                            disabled: true
                          }, null, 8, _hoisted_15)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_a_form_item, {
                        label: "Alíquota PIS",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            "quantidade-casas-decimais": 2,
                            percentual: true,
                            valor: _ctx.state.servico.aliquotaPis,
                            "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.servico.aliquotaPis) = $event)),
                            disabled: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_a_form_item, {
                        label: "Alíquota COFINS",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            "quantidade-casas-decimais": 2,
                            percentual: true,
                            valor: _ctx.state.servico.aliquotaCofins,
                            "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.servico.aliquotaCofins) = $event)),
                            disabled: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_a_form_item, {
                        label: "Alíquota INSS",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            "quantidade-casas-decimais": 2,
                            percentual: true,
                            valor: _ctx.state.servico.aliquotaInss,
                            "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.servico.aliquotaInss) = $event)),
                            disabled: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_a_form_item, {
                        label: "Alíquota IR",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            "quantidade-casas-decimais": 2,
                            percentual: true,
                            valor: _ctx.state.servico.aliquotaIr,
                            "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.servico.aliquotaIr) = $event)),
                            disabled: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_a_form_item, {
                        label: "Alíquota CSLL",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            "quantidade-casas-decimais": 2,
                            percentual: true,
                            valor: _ctx.state.servico.aliquotaCsll,
                            "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.servico.aliquotaCsll) = $event)),
                            disabled: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.state.dados.codigoServico > 0)
            ? (_openBlock(), _createBlock(_component_card, {
                key: 0,
                class: "ss-card-alinhado",
                titulo: "AJUSTAR TÍTULOS"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_a_form_item, {
                        label: "Descrição Adicional",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.descricaoAdicional) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.descricaoAdicional]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_a_form_item, {
                        label: "ISS Retido",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_iss_retido, {
                            valor: _ctx.state.issRetido,
                            "onUpdate:valor": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.issRetido) = $event))
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_a_form_item, {
                        label: "Alíquota ISS",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            "quantidade-casas-decimais": 2,
                            percentual: true,
                            valor: _ctx.state.aliquotaIss,
                            "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.aliquotaIss) = $event))
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_a_form_item, {
                        label: " ",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            type: "button",
                            class: "ant-btn ant-btn-secondary",
                            style: {"width":"100%"},
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.alterarTitulosSelecionados && _ctx.alterarTitulosSelecionados(...args)))
                          }, "Ajustar")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_card, {
            class: "ss-card-alinhado",
            titulo: "DADOS DOS TÍTULOS"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_table, {
                columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                "data-source": _ctx.state.dados.titulosFinanceiros,
                rowKey: "codigo",
                pagination: false,
                "row-selection": { selectedRowKeys: _ctx.state.selecionados, onChange: _ctx.selecaoAlterada,  },
                loading: _ctx.telaBase.carregando,
                size: "small"
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.key === 'Pessoa')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        title: record.pessoaApresentacao
                      }, _toDisplayString(record.pessoaApresentacao), 9, _hoisted_26))
                    : (column.key === 'TituloFinanceiro')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("span", {
                            title: _ctx.montaApresentacaoTitulo(record)
                          }, _toDisplayString(_ctx.montaApresentacaoTitulo(record)), 9, _hoisted_27),
                          ((record.valorDesconto > 0))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_28,
                                _createVNode(_component_a_radio_group, {
                                  value: record.descontoInCondicionado,
                                  "onUpdate:value": ($event: any) => ((record.descontoInCondicionado) = $event)
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, { value: true }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Desconto Incondicionado")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: false }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Desconto Condicionado")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["value", "onUpdate:value"])
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (column.key === 'Valor')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, "R$" + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.obtemValorTitulo(record))), 1))
                        : (column.key === 'IssRetido')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(record.issRetido == 1 ? 'Não' : 'Sim'), 1))
                          : (column.key === 'AliquotaIss')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.aliquotaIss)) + "%", 1))
                            : (column.key === 'ValorLiquido')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, "R$" + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.obtemValorNfse(record))), 1))
                              : (column.key === 'TituloFinanceiroMobile')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createElementVNode("span", null, [
                                      _hoisted_34,
                                      _createTextVNode(" " + _toDisplayString(record.siglaTipoDocumentoFinanceiro + ' - ' +
                  record.descricaoTipoDocumentoFinanceiro), 1)
                                    ]),
                                    _createElementVNode("span", null, [
                                      _hoisted_35,
                                      _createTextVNode(" " + _toDisplayString(record.numeroTitulo), 1)
                                    ]),
                                    _createElementVNode("span", null, [
                                      _hoisted_36,
                                      _createTextVNode(" " + _toDisplayString(record.pessoaApresentacao), 1)
                                    ]),
                                    _createElementVNode("span", null, [
                                      _hoisted_37,
                                      _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataVencimento)), 1)
                                    ]),
                                    _createElementVNode("span", null, [
                                      _hoisted_38,
                                      _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.obtemValorNfse(record), 2)), 1)
                                    ]),
                                    _createElementVNode("span", null, [
                                      _hoisted_39,
                                      _createTextVNode(" " + _toDisplayString(record.descricaoConta), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["columns", "data-source", "row-selection", "loading"]),
              ((_ctx.state.apresentarAcaoDesconto))
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.state.descontoInCondicionado,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.descontoInCondicionado) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, { value: true }, {
                            default: _withCtx(() => [
                              _createTextVNode("Desconto Incondicionado")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: false }, {
                            default: _withCtx(() => [
                              _createTextVNode("Desconto Condicionado")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ant-btn ant-btn-sm ant-btn-secondary",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.aplicarDescontoEmTodosTitulos()))
                      }, _hoisted_45)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_card, {
            class: "ss-card-alinhado",
            titulo: "TOTAIS"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_totalizador, {
                    titulo: "QUANTIDADES",
                    valor: _ctx.state.quantidadesTitulos,
                    casasDecimais: 0
                  }, null, 8, ["valor"])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_component_totalizador, {
                    titulo: "VALOR TOTAL SERVIÇOS",
                    monetario: true,
                    valor: _ctx.state.totalServicos
                  }, null, 8, ["valor"])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_totalizador, {
                    titulo: "VALOR TOTAL DESCONTOS",
                    monetario: true,
                    valor: _ctx.state.totalDescontos
                  }, null, 8, ["valor"])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_component_totalizador, {
                    titulo: "VALOR TOTAL NFSEs",
                    monetario: true,
                    valor: _ctx.state.totalNfses
                  }, null, 8, ["valor"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible"]))
}